import { render, staticRenderFns } from "./BidSubjectDetail.vue?vue&type=template&id=012796ce&scoped=true&"
import script from "./BidSubjectDetail.vue?vue&type=script&lang=js&"
export * from "./BidSubjectDetail.vue?vue&type=script&lang=js&"
import style0 from "./BidSubjectDetail.vue?vue&type=style&index=0&id=012796ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012796ce",
  null
  
)

export default component.exports